<a class="tag-button" mat-flat-button [routerLink]="Link()" (click)="(click)">
  <span>{{ Text() }}</span>
</a>
